import React, { useState, useEffect } from "react";
import { validateInput } from "../../blueplanitUtils/validationUtils";
import { message } from "antd";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { handleClose } from "../ProfileEditpopUp/HandleClosePop/handleclose";
import { SelectInput, InputField, DatePickerField } from "../../blueplanitUtils/InputField";
import { useFormHandler } from "../../blueplanitUtils/EmployeeSubmitFun";
import { setUserDatas, SideMenu, SetAllEmployees, updateNoteData, } from "../../Slices/employeeslice";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { setreupdate, } from "../../Slices/DyanamicRoute";
import Modal from "../../blueplanitUtils/Modal";
import { TextAreayModelPopUp } from "../../blueplanitUtils/TextAreaModelPopUp";
import { handleKeyDown } from "../../blueplanitUtils/DatePickerAutoformate"
import { getOptionsByPath, useNestedDropdownHandler } from "../../utilsdata";
import { EMPLOYEE_PROCESS_SPECIALIZATION, EMPLOYEE_BDE, EMPLOYEE_TECHNICAL_SPECIALIZATION } from "../../Dropdownmanager";
import { EMPLOYEE_DEPARTMENT, ADD_EDIT_EMPLOYEE, GENDER, USER_TYPE, BLOOD_GROUP, MARITAL_STATUS, ADD_EDIT_EMPLOYEE_DESIGNATION, EMPLOYEE_STATUS, RESIGNATION_STATUS, EMPLOYEMENT_STATUS_INFO } from "../../Dropdownmanager";


const PersonalInformationModelPopup = (props) => {
  const { handleSubmit } = useFormHandler()
  const name = props?.name;
  const setEmpupdate = props?.setEmpupdate ?? (() => { });

  const dispatch = useDispatch();
  const { Empid } = useParams();
  const [note, setNote] = useState();
  // Marking someone InActive is not just a status flip — payroll pays a leaver up
  // to their last working day and drops them from every month without one. So the
  // exit details are captured at the moment the status changes, not left to a
  // different popup that nobody remembers to open.
  // lastWorkingDay / resignationStatus are NOT part of userData - they live in the
  // employment slice, edited by the separate Employment Status popup. Reading them
  // from userData showed blanks even for someone who already had both on file.
  const employmentInfo = useSelector((state) => state.employee.employmentData);
  const [isUserDataValid, setIsUserDataValid] = useState(false);
  const [updatedRoutes, setUpdatedRoutes] = useState([]);
  const UserDataup = useSelector((state) => state.employee.userData);
  const notess = useSelector((state) => state.employee.notes)
  const AllEmployees = useSelector((state) => state.employee.AllEmployees);
  const clientOptions = useSelector(state => state.clients.clients);
  const route = useSelector((state) => state.Route.empRoute);
  const NestedDatabucket = useSelector((state) => state.dataBucket.NestedDatabucket);
  const Departmentoptions = getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT]);
  const ProcessSpecialization = getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE_DESIGNATION, EMPLOYEE_PROCESS_SPECIALIZATION]);
  const BusinessDevelopment = getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE_DESIGNATION, EMPLOYEE_BDE]);
  const TechnicalSpecialization = getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE_DESIGNATION, EMPLOYEE_TECHNICAL_SPECIALIZATION]);

  const { selectedId, selectedValue, handleChange } = useNestedDropdownHandler(Departmentoptions, "department");


  const activeClientOptions = clientOptions
    ?.filter(clientOption => clientOption?.status === "Active" || clientOption?.status === "active")
    .map(clientOption => ({
      label: clientOption?.clientName,
      value: clientOption?.clientName,
    }));

  useEffect(() => {
    const targetNote = notess.find((note) => note?.name === name);
    if (targetNote) {
      setNote(targetNote?.data);
    }
    setUserData({
      EmpID: UserDataup?.EmpID,
      firstname: UserDataup?.firstname,
      lastname: UserDataup?.lastname,
      dob: UserDataup?.dob || '',
      salaryCTC: UserDataup?.salaryCTC || '',
      gender: UserDataup?.gender,
      currentAddress: UserDataup?.currentAddress,
      mobile: UserDataup?.mobile,
      department: UserDataup?.department,
      designation: UserDataup?.designation,
      reportingTo: UserDataup?.reportingTo,
      bloodGroup: UserDataup?.bloodGroup,
      permanentAddress: UserDataup?.permanentAddress,
      alternativeNumber: UserDataup?.alternativeNumber,
      maritalStatus: UserDataup?.maritalStatus,
      employeestatus: UserDataup?.employeestatus || '',
      processSplization: UserDataup?.processSplization || '',
      email: UserDataup?.email || '',
      DateOfJoining: UserDataup?.DateOfJoining || '',
      personalEmail: UserDataup?.personalEmail || '',
      role: UserDataup?.role || '',
      clients: UserDataup?.clients || '',
      additionalRoles: UserDataup?.additionalRoles || [],
    });
    if (UserDataup?.department) {
      handleChange(UserDataup.department);
    }
  }, [UserDataup])

  const names = AllEmployees
    .filter(item => item.employeestatus === "Active")
    .map((item, index) => ({
      key: index,
      label: `${item.firstname} ${item.lastname}`,
      value: `${item.firstname} ${item.lastname}`,
    }));

  const [userData, setUserData] = useState({
    EmpID: "",
    firstname: "",
    lastname: "",
    dob: "",
    salaryCTC: "",
    gender: "",
    currentAddress: "",
    mobile: "",
    department: "",
    DateOfJoining: "",
    designation: "",
    reportingManager: "",
    employeestatus: "",
    bloodGroup: '',
    permanentAddress: '',
    maritalStatus: '',
    processSplization: [],
    alternativeNumber: '',
    email: '',
    clients: '',
    personalEmail: '',
    role: '',
    additionalRoles: [],
  });

  useEffect(() => {
    if (userData.role !== UserDataup?.role && userData.department !== UserDataup?.department) {

      const ROUTE = route?.find(
        (item) =>
          item?.name === userData?.role && item?.department === userData?.department
      );
      if (!ROUTE) {

        return;
      }

      const formattedData = ROUTE?.fields?.map((menu) => ({
        name: menu.name,
        status: menu.status,
        mainId: menu.mainId,
        Subfields: menu.Subfields?.map((sub) => ({
          displayName: sub.displayName || "MISSING", // Debugging
          name: sub.name,
          subId: sub.subId,
          status: sub.status,
        })) || [],
      }));
      if (formattedData?.length === 0) {
      }
      setUpdatedRoutes(formattedData);
    }
  }, [userData.role, userData.department]);


  const [errores, setErrores] = useState({});
  const [fieldupdate, setfieldupdate] = useState(false)

  const isInactiveValue = (v) => /^in\s*-?\s*active$/i.test(String(v || "").trim());
  const goingInactive = isInactiveValue(userData?.employeestatus);
  // An exit date already on file. Needed because the submit below DELETES empty
  // exit fields from the payload (so an untouched form can't blank a stored
  // value) — which also means clearing a field by hand does nothing. Someone
  // re-hired or marked Active again would keep a past last working day, and
  // payroll drops an employee from every month after theirs. Clearing therefore
  // has to be an explicit action, not an empty input.
  const exitOnFile = !!(userData?.lastWorkingDay || employmentInfo?.lastWorkingDay);
  const [clearExit, setClearExit] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setfieldupdate(true);
    setUserData((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "department" && { designation: "" }),
    }));
    const error = validateInput(name, value);
    setErrores((prev) => ({ ...prev, [name]: error }));
  };
  useEffect(() => {
    const requiredFields = ['mobile', 'EmpID', 'personalEmail', 'email', 'firstname', 'lastname', 'dob', 'gender', 'DateOfJoining'];
    const allFieldsValid = requiredFields.every((field) => {
      return userData[field] && !errores[field]; // Ensure field has a value and no error
    });
    const isAlternativeNumberValid = !errores['alternativeNumber'];
    // InActive cannot be saved without an exit date - payroll dates a leaver from it.
    const exitOk = !isInactiveValue(userData.employeestatus)
      || (!!userData.lastWorkingDay && !!String(userData.resignationStatus || "").trim());
    const isFormValid = allFieldsValid && isAlternativeNumberValid && exitOk;
    setIsUserDataValid(isFormValid);
  }, [userData, errores]);

  // Carry whatever is already on file into the form, so an employee who already
  // has an exit date does not have to re-enter it.
  useEffect(() => {
    if (!employmentInfo) return;
    // Only ever copy REAL values in, and never overwrite something already typed.
    // Seeding "" here would put a blank into the payload (userData is spread whole
    // on submit) and wipe an exit date that was already on the record.
    setUserData((prev) => {
      const patch = {};
      if (!prev.lastWorkingDay && employmentInfo.lastWorkingDay) patch.lastWorkingDay = employmentInfo.lastWorkingDay;
      if (!prev.resignationStatus && employmentInfo.resignationStatus) patch.resignationStatus = employmentInfo.resignationStatus;
      return Object.keys(patch).length ? { ...prev, ...patch } : prev;
    });
  }, [employmentInfo]);

  const personalhandleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const requiredFields = [
      "EmpID",
      "mobile",
      "email",
      "firstname",
      "alternativeNumber",
      "personalEmail",
      "lastname",
      "gender",
      "dob",
      "DateOfJoining",
    ];
    const newErrors = requiredFields.reduce((acc, field) => {
      const error = validateInput(field, userData[field]);
      if (error) acc[field] = error;
      return acc;
    }, {});

    setErrores(newErrors);
    const noErrors = Object.keys(newErrors).length === 0;
    const { id, ...dataWithoutEmpid } = userData;
    if (clearExit && !goingInactive) {
      // The one case where an empty value is DELIBERATE: the user asked to wipe
      // the exit details because this employee is back on the roll. Sent as
      // explicit empty strings so the record is actually cleared.
      dataWithoutEmpid.lastWorkingDay = "";
      dataWithoutEmpid.resignationStatus = "";
    } else {
      // Never send these as empty strings - an absent value must leave the stored
      // one untouched rather than blanking it.
      if (!dataWithoutEmpid.lastWorkingDay) delete dataWithoutEmpid.lastWorkingDay;
      if (!String(dataWithoutEmpid.resignationStatus || "").trim()) delete dataWithoutEmpid.resignationStatus;
    }

    let input = updatedRoutes.length > 0
      ? { ...dataWithoutEmpid, menu: updatedRoutes }
      : { ...dataWithoutEmpid };

    try {
      const val = await handleSubmit({
        noErrors,
        formValid: noErrors && fieldupdate,
        dataObj: input,
        action: "PersonalInformation",
        ModalName: "PersonalInformationModalpopup",
        submitAction: "PeraonalInformational Handle submit",

      });
      if (val) {
        setIsUserDataValid(false)
        setfieldupdate(false)
        dispatch(setUserDatas(userData));
        if (updatedRoutes.length > 0)
          dispatch(SideMenu(updatedRoutes));
        const updatedEmployees = AllEmployees.map((employee) =>
          employee.id === Empid
            ? {
              ...employee,
              firstname: userData.firstname || employee.firstname,
              lastname: userData.lastname || employee.lastname,
              department: userData.department || employee.department,
              designation: userData.designation || employee.designation,
              employeestatus:
                userData.employeestatus || employee.employeestatus,
              role: userData.role || employee.role,
            }
            : employee
        );

        dispatch(SetAllEmployees(updatedEmployees));

        dispatch(setreupdate(true));
        setEmpupdate(true);
      }

    }
    catch (error) {
      message.error({
        content: error.message || "Something went wrong",
        duration: 5,
        className: "alert alert-danger text-center",
      });
    } finally {
      setIsUserDataValid(false);
    }
  };
  const [noteChange, setNoteChange] = useState(false);
  const handleNoteChange = (event) => {
    setNoteChange(true);
    setNote(event.target.value);
  };
  const handleNoteSubmit = async (event) => {
    event.preventDefault();
    try {
      if (noteChange) {
        const input = {
          [name]: note,
        }
        const val = await handleSubmit({
          noErrors: true,
          formValid: noteChange,
          dataObj: input,
          action: "NoteChange",
          ModalName: "NoteChangePopUp",
          submitAction: "NoteChangeSubmit",
        });

        if (val) {
          dispatch((updateNoteData({ data: note, name: name })));
          setNoteChange(false);
        }

      }
    }
    catch (error) {
    } finally {

    }
  };



  return (
    <>
      <Modal
        id="profile_info"
        title="Edit profile"
        handleModalClose={() => handleClose(UserDataup, setUserData, setErrores)}
        handleSubmit={personalhandleSubmit}
        isUserDataValid={false}
      >
        <div className="row">
          <div className="col-md-6 mb-2">
            <InputField
              required={true}
              label="Employee ID"
              type="number"
              name="EmpID"
              value={(userData?.EmpID)?.trim() || ""}
              onChange={handleInputChange}
              error={errores.EmpID}
              max="99999"
              min="0"
              formcontrol="form-control"
              onInput={(e) => {
                if (e.target.value.length > 5) {
                  e.target.value = e.target.value.slice(0, 5);
                }
              }}
            />
          </div>
          <div className="col-md-6 mb-2">
            <DatePickerField
              formcontrol="form-control"
              required={true}
              label="Date of Joining"
              name="DateOfJoining"
              format="DD/MM/YYYY"
              value={userData?.DateOfJoining ? dayjs(userData.DateOfJoining) : null} // Ensure dayjs format
              onChange={(date) => {
                const isoString = date ? date.toISOString() : null;
                handleInputChange({
                  target: {
                    name: "DateOfJoining",
                    value: isoString, // Extract formatted date string
                  },
                })
              }}
              error={errores?.DateOfJoining}
              max={dayjs().add(1, 'year')} // Ensure maxDate is a dayjs object
              onKeyDown={handleKeyDown}
              style={{ width: "100%" }}
            /></div>
        </div>
        <div className="row">
          <div className="col-md-6 mb-2">
            <InputField
              formcontrol="form-control"
              label="First Name"
              type="text"
              name="firstname"
              value={userData?.firstname}
              onChange={handleInputChange}
              error={errores.firstname}
              required={true}
            />
          </div>
          <div className="col-md-6 mb-2">
            <InputField
              formcontrol="form-control"
              label="Last Name"
              type="text"
              name="lastname"
              value={userData?.lastname}
              onChange={handleInputChange}
              error={errores.lastname}
              required={true}
            />
          </div>
          <div className="col-md-6 mb-2">
            <DatePickerField
              formcontrol="form-control"
              label="Birth Date"
              name="dob"
              value={userData?.dob ? dayjs(userData.dob) : null} // Convert stored value to Day.js
              format="DD/MM/YYYY" // Ensure the correct date format
              onChange={(date, dateString) => {
                handleInputChange({
                  target: {
                    name: "dob",
                    value: date, // Ensure storing in string format
                  },
                });
              }}
              error={errores?.dob}
              required={true}
              onKeyDown={handleKeyDown}
              style={{ width: "100%" }}
            />
          </div>
          <div className="col-md-6 mb-2">
            <SelectInput
              label="Gender"
              name="gender"
              value={userData?.gender}
              onChange={(e) =>
                handleInputChange({
                  target: {
                    name: "gender",
                    value: e,
                  }
                })
              }
              options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, GENDER])}
              formControl={true}
              style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
              error={errores.gender}
              required={true}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 mb-2">
            <InputField
              formcontrol="form-control"
              label="Current Address"
              type="text"
              name="currentAddress"
              value={userData?.currentAddress}
              onChange={handleInputChange}
            />
          </div>
          <div className="col-md-12 mb-2">
            <InputField
              formcontrol="form-control"
              label="Permanent Address"
              type="text"
              name="permanentAddress"
              value={userData?.permanentAddress}
              onChange={handleInputChange}
            />
          </div>
          <div className="col-md-6 mb-2">
            <InputField
              formcontrol="form-control"
              label="Phone Number"
              type="text"
              name="mobile"
              value={userData?.mobile?.trim()}
              onChange={handleInputChange}
              error={errores.mobile}
              required={true}
            />
          </div>
          <div className="col-md-6 mb-2">
            <InputField
              formcontrol="form-control"
              label="Alternative Number"
              type="text"
              name="alternativeNumber"
              value={userData?.alternativeNumber?.trim()}
              onChange={handleInputChange}
              error={errores.alternativeNumber}
            />
          </div>
          <div className="col-md-6 mb-2">
            <InputField
              formcontrol="form-control"
              label="Email"
              type="text"
              name="email"
              value={userData?.email?.trim()}
              onChange={handleInputChange}
              error={errores.email}
              required={true}
            />
          </div>
          <div className="col-md-6 mb-2">
            <InputField
              required={true}
              formcontrol="form-control"
              label="Personal Email"
              type="text"
              name="personalEmail"
              value={userData?.personalEmail?.trim()}
              onChange={handleInputChange}
              error={errores.personalEmail}

            />
          </div>
          <div className="col-md-6 ">
            <SelectInput
              label="Reporting To"
              name="reportingTo"
              value={userData?.reportingTo}
              onChange={(e) =>
                handleInputChange({
                  target: {
                    name: "reportingTo",
                    value: e,
                  }
                })
              }
              formControl={true}
              options={names}
              style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
              error={errores.department}

            />
          </div>
          <div className="col-md-6">
            <SelectInput
              label="Department"
              name="department"
              value={selectedValue}
              onChange={(value) => handleChange(value, handleInputChange)}
              formControl={true}
              options={Departmentoptions}
              style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
              error={errores.department}

            />
          </div>
          <div className="col-md-6">
            <SelectInput
              label="UserType"
              name="role"
              value={userData?.role}
              onChange={(e) =>
                handleInputChange({
                  target: {
                    name: "role",
                    value: e,
                  }
                })
              }
              formControl={true}
              options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, USER_TYPE])}
              style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
              error={errores.role}
            />
          </div>
          {(userData.department === "Operations" || userData.department === "Sales" || userData.department === "IT") && (
            <div className="col-md-6">
              <SelectInput
                mode="multiple"// Corrected spelling
                formControl={true}
                label=
                {userData.department === "Sales"
                  ? "Sales Specialization"
                  : userData.department === "IT"
                    ? "Technical Specialization"
                    : "Process Specialization"
                }
                name="processSplization"
                value={userData?.processSplization || []} // Ensure it's always an array
                onChange={(selectedValues) =>
                  handleInputChange({
                    target: {
                      name: "processSplization",
                      value: selectedValues, // Extract only values
                    },
                  })
                }
                options=
                {userData.department === "Operations"
                  ? ProcessSpecialization
                  : userData.department === "Sales"
                    ? BusinessDevelopment
                    : userData.department === "IT"
                      ? TechnicalSpecialization
                      : []
                }
                style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                error={errores.employeestatus}
              />

            </div>
          )}
          <div className="col-md-6">
            <SelectInput
              label="Status"
              name="employeestatus"
              value={userData?.employeestatus}
              onChange={(e) =>
                handleInputChange({
                  target: {
                    name: "employeestatus",
                    value: e,
                  }
                })
              }
              options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, EMPLOYEE_STATUS])}
              formControl={true}
              style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
              error={errores.employeestatus}
            />
          </div>
          {/* Exit details, required before an employee can be saved as InActive.
              Rendered inline inside this form - NOT in a nested modal - because the
              Bootstrap modal traps focus, so a dropdown portalled outside it closes
              the instant an option is clicked. The Selects around it work for the
              same reason: they live in this DOM. */}
          {goingInactive && (
            <div className="col-md-12">
              <div style={{ background: "#FFFBEB", border: "1px solid #FDE68A", borderRadius: 8, padding: "10px 14px 2px", marginBottom: 12 }}>
                <div style={{ fontSize: 12, color: "#92400E", marginBottom: 8, lineHeight: 1.5 }}>
                  <strong>Exit details required.</strong> Payroll pays this employee up to their
                  last working day. Without it they are dropped from every month — including one
                  they have already worked.
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <DatePickerField
                      label="Last working day"
                      name="lastWorkingDay"
                      required={true}
                      format="DD/MM/YYYY"
                      value={userData?.lastWorkingDay ? dayjs(userData.lastWorkingDay) : null}
                      onChange={(date) =>
                        handleInputChange({ target: { name: "lastWorkingDay", value: date ? date.toISOString() : "" } })
                      }
                      onKeyDown={handleKeyDown}
                      error={!userData?.lastWorkingDay ? "Last working day is required." : ""}
                    />
                  </div>
                  <div className="col-md-6">
                    <SelectInput
                      label="Resignation status"
                      name="resignationStatus"
                      required={true}
                      formControl={true}
                      value={userData?.resignationStatus || undefined}
                      options={getOptionsByPath(NestedDatabucket, [EMPLOYEMENT_STATUS_INFO, RESIGNATION_STATUS])}
                      onChange={(v) => handleInputChange({ target: { name: "resignationStatus", value: v } })}
                      style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                      error={!String(userData?.resignationStatus || "").trim() ? "Resignation status is required." : ""}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* The counterpart to the block above. Clearing a field by hand does
              nothing here (empty values are stripped from the payload), so
              putting someone back on the roll needs an explicit action — without
              it their old last working day stands and payroll keeps dropping
              them from every month after it. */}
          {!goingInactive && exitOnFile && (
            <div className="col-md-12">
              <div style={{ background: clearExit ? "#FEF2F2" : "#F8FAFC", border: `1px solid ${clearExit ? "#FECACA" : "#E2E8F0"}`, borderRadius: 8, padding: "10px 14px", marginBottom: 12 }}>
                <div style={{ fontSize: 12, color: "#334155", lineHeight: 1.5 }}>
                  <strong>Exit details are on file</strong> for this employee — last working day{" "}
                  {dayjs(userData?.lastWorkingDay || employmentInfo?.lastWorkingDay).format("DD/MM/YYYY")}
                  {(userData?.resignationStatus || employmentInfo?.resignationStatus)
                    ? `, resignation: ${userData?.resignationStatus || employmentInfo?.resignationStatus}`
                    : ""}
                  . They are not marked InActive, so payroll will still stop paying them after that date.
                </div>
                <label style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 8, fontSize: 12, fontWeight: 600, color: clearExit ? "#B91C1C" : "#334155" }}>
                  <input type="checkbox" checked={clearExit} onChange={(e) => setClearExit(e.target.checked)} />
                  Clear the exit details on save — this employee is back on the roll
                </label>
              </div>
            </div>
          )}
          {/* <div className="col-md-6">
            <SelectInput
              formControl={true}
              label="Access"
              name="accessType"
              value={userData?.accessType}
              required={true}
              onChange={(value) =>
                handleInputChange({
                  target: {
                    name: "accessType",
                    value,
                  },
                })
              }
              options={[
                { label: "Web Application", value: "WEB" },
                { label: "Desktop Application", value: "DESKTOP" },
                { label: "Web + Desktop", value: "BOTH" },
              ]}
              placeholder="Select Access"
              error={errores.accessType}
            />
          </div> */}

          {userData.department === "Operations" && (
            <div className="col-md-6">
              <SelectInput
                label="Client"
                name="clients"
                value={userData?.clients}
                onChange={(e) =>
                  handleInputChange({
                    target: {
                      name: "clients",
                      value: e,
                    }
                  })
                }
                formControl={true}
                options={activeClientOptions}
                style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
                error={errores.clients}
              />
            </div>
          )}
          <div className="col-md-6">
            <SelectInput
              formControl={true}
              label="designation"
              name="designation"
              value={userData?.designation}
              onChange={(e) => {
                handleInputChange({
                  target: {
                    name: "designation",
                    value: e,
                  }
                })
              }}

              options={getOptionsByPath(NestedDatabucket, [...[ADD_EDIT_EMPLOYEE, EMPLOYEE_DEPARTMENT], selectedId])}
              style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
              error={errores.department}
            />
          </div>
          <div className="col-md-6">
            <SelectInput
              label="Marital Status"
              options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, MARITAL_STATUS])}
              value={userData?.maritalStatus}
              onChange={(e) =>
                handleInputChange({
                  target: {
                    name: "maritalStatus",
                    value: e,
                  }
                })
              }
              formControl={true}
              name="maritalStatus"
              style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}
              error={errores.maritalStatus}
            />
          </div>
          <div className="col-md-6">
            <SelectInput
              label="Blood Group"
              options={getOptionsByPath(NestedDatabucket, [ADD_EDIT_EMPLOYEE, BLOOD_GROUP])}
              value={userData?.bloodGroup}
              onChange={(e) =>
                handleInputChange({
                  target: {
                    name: "bloodGroup",
                    value: e,
                  }
                })
              }
              name="bloodGroup"
              formControl={true}
              style={{ height: "100%", minHeight: "40px", lineHeight: "40px", border: "none" }}

            />
          </div>

          {userData.department && userData.department !== "Sales" && (
            <div className="col-md-6" style={{ display: "flex", alignItems: "center", marginTop: 8 }}>
              <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 14 }}>
                <input
                  type="checkbox"
                  checked={(userData.additionalRoles || []).includes("Sales")}
                  onChange={(e) => {
                    const roles = [...(userData.additionalRoles || [])];
                    if (e.target.checked) {
                      if (!roles.includes("Sales")) roles.push("Sales");
                    } else {
                      const idx = roles.indexOf("Sales");
                      if (idx >= 0) roles.splice(idx, 1);
                    }
                    handleInputChange({ target: { name: "additionalRoles", value: roles } });
                  }}
                  style={{ width: 16, height: 16 }}
                />
                Handles Sales Responsibilities
              </label>
            </div>
          )}

        </div>


      </Modal>


      <TextAreayModelPopUp
        id="note_modal_popup"
        title="Add Note"
        handleSubmit={handleNoteSubmit}
        noteChange={handleNoteChange}
        data={note}
      >
      </TextAreayModelPopUp>
    </>
  );
};

export default PersonalInformationModelPopup;
